import Vue from "vue";
import router from "./router";
import store from "./store";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style

import { getQueryObject } from "./utils";
NProgress.configure({
  showSpinner: false,
}); // NProgress Configuration

const whiteList = ["/signin"]; // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start(); // start progress bar
  if (store.getters.token && store.getters.token != "") {
    // determine if there has token
    if (!store.getters.addRouters.length) {
      store
        .dispatch("GenerateRoutes", {
          roles: store.getters.roles,
          isSuper: store.getters.user.isSuper,
        })
        .then(() => {
          // store.getters.addRouters.map((e) => {
          //   router.addRoute(e);
          // });
          next({ path: to.fullPath });
        });
    } else {
      next();
    }
  } else {
    /* has no token*/
    // if (location.search) {
    //   const search = getQueryObject(location.search);
    //   if (search.code) {
    //     if (to.path != "/auth-redirect") {
    //       next({
    //         path: "/auth-redirect",
    //         replace: true,
    //         query: {
    //           logincode: search.code,
    //         },
    //       });
    //     } else {
    //       next();
    //     }
    //   }
    //   return;
    // }
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      next(process.env.VUE_APP_LOGIN_PATH); // 否则全部重定向到登录页
      NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
});

router.afterEach(() => {
  NProgress.done(); // finish progress bar
});
